import { render, staticRenderFns } from "./volunteerHub.vue?vue&type=template&id=9a66e9ae&scoped=true"
import script from "./volunteerHub.vue?vue&type=script&lang=js"
export * from "./volunteerHub.vue?vue&type=script&lang=js"
import style0 from "./volunteerHub.vue?vue&type=style&index=0&id=9a66e9ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a66e9ae",
  null
  
)

export default component.exports